<template>
  <div class="card second-dash-card mt-4">
    <div class="row g-0">
      <div class="col-md-12 col-lg-7 col-xl-7 col-xxl-7">
        <div class="card text-white service-card m-1">
          <div class="d-flex Tpsrow justify-content-between ps-3 pt-3 pe-3">
            <span class="heading-26 fw-bold">Transactions Per Second</span>

            <div class="d-flex align-items-center gap-2 iconimg">
              <img :src="AT" alt="Logo" class="graph-img-SD" />

              <div class="tpsfont">
                <span class="tps-heading ps-1">Today's average TPS stands at
                  <span class="at-blue">{{ at }}</span></span>
              </div>
            </div>

            <div class="d-flex align-items-center gap-2 iconimg">
              <img :src="Peak" alt="Logo" class="graph-img-SD" />

              <div class="tpsfont">
                <span class="tps-heading ps-1">Today's peak TPS at <span class="at-blue">{{ pk }}</span> as
                  of <span class="at-blue">{{ formattedTime(dt) }}</span></span>
              </div>
            </div>
          </div>
          <div class="row mt-3 ps-3 pb-3 pe-3 mb-4">
            <div id="tps" style="height: 12.5rem; width: 100%"></div>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-5 col-xl-5 col-xxl-5">
        <div class="card text-white service-card m-1 ps-3 pt-3 pe-3">
          <div class="row">
            <div class="col-md-4 col-lg-4">
              <span class="heading-26 fw-bold">Service Availability</span>
            </div>
            <div class="col-md-8 col-lg-8">
              <span class="d-flex justify-content-end datefont fs-6 heading-14">Year-to-Date data as of
                {{ daymonthyear(Servicedata?.To_Date_Query) }}</span>
            </div>
          </div>
          <div class="row perRow">
            <div class="col-md-4 col-lg-4 d-flex flex-column justify-content-center align-items-center">
              <div class="row borderclass">
                <span class="d-flex justify-content-center align-content-center heading-32">Overall</span>
                <span class="d-flex justify-content-center align-content-center service-span1 mx-1 heading-38">{{
                  Servicedata?.overall }}%</span>
              </div>
            </div>
            <div class="col-md-8 col-lg-8 d-flex flex-column justify-content-center servicetrack">
              <div class="row">
                <span class="heading-32">Retail Payments Platform</span>
              </div>
              <div class="row mb-2">
                <div class="col-md-8 col-lg-8">
                  <input type="range" v-model="RPP" />
                </div>
                <div class="col-md-4 col-lg-4">
                  <span class="serviceValue d-flex justify-content-center px-3 service-span2 mx-3">{{
                    Servicedata?.retail_payment_platform }}%</span>
                </div>
              </div>

              <div class="row">
                <span class="heading-32">FPX</span>
              </div>
              <div class="row mb-2">
                <div class="col-md-8 col-lg-8">
                  <input type="range" v-model="FPX" />
                </div>
                <div class="col-md-4 col-lg-4">
                  <span class="serviceValue d-flex justify-content-center px-3 service-span2 mx-3">{{ Servicedata?.fpx
                    }}%</span>
                </div>
              </div>

              <div class="row">
                <span class="heading-32">MyDebit</span>
              </div>
              <div class="row mb-3">
                <div class="col-md-8 col-lg-8">
                  <input type="range" v-model="MyDebit" />
                </div>
                <div class="col-md-4 col-lg-4">
                  <span class="serviceValue d-flex justify-content-center px-3 service-span2 mx-3">{{
                    Servicedata?.mydebit }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {  config ,setAuthToken} from '@/config';
import Highcharts from "highcharts";
const AverageTransaction = process.env.https://api.nrtdashboard.prod.inet.paynet.my/paynet/api/get-transaction-graph-data;
const Transactiongraph = process.env.https://api.nrtdashboard.prod.inet.paynet.my/paynet/api/get-transaction-avg-peak-data;
const ServiceAvailable = process.env.https://api.nrtdashboard.prod.inet.paynet.my/paynet/api/get-service-avail-data;
export default {
  name: "second-dashboard",

  components: {},

  data: () => ({
    AT: require("@/assets/newIcon/tps1.svg"),
    Peak: require("@/assets/newIcon/tps2.svg"),
    NationalData: 0,
    Servicedata: 0,
    AvgPeak: 0,
    at: 0,
    pk: 0,
    dt: 0,
    RPP: 0,
    FPX: 0,
    MyDebit: 0,
    intervalId1: 0,
    intervalId2: 0,
    currentMinute: null,
    transactiongp: [],
    mins: process.env.VUE_APP_MINS
  }),
  mounted() {
    this.gettransactiongraph();
    this.getservice();
    this.getavgpeak();
    this.intervalId1 = setInterval(this.serviceMovements, 31000);
    this.intervalId2 = setInterval(() => {
      this.currentMinute = new Date().getMinutes();
      this.updateChartData();
    }, 60000);
    this.currentDate1 = new Date();
    const now = new Date();
    const minutes = now.getMinutes();
    const nextMinute = Math.ceil((minutes + 1) / this.mins) * this.mins;

    const nextCall = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      now.getHours(),
      nextMinute,
      0
    );

    let delay = nextCall - now;
    if (delay < 0) {
      delay += this.mins * 60 * 1000;
    }

    setTimeout(() => {
      this.gettransactiongraph();
      setInterval(() => {
        this.gettransactiongraph();
      }, this.mins * 60 * 1000); 
    }, delay);
  },
  beforeUnmount() {
    clearInterval(this.intervalId1, this.intervalId2);
  },
  methods: {
    formattedTime(timevalue) {
      const time = new Date(timevalue);
      const hours = String(time.getHours()).padStart(2, "0");
      const minutes = String(time.getMinutes()).padStart(2, "0");
      return hours + ":" + minutes;
    },
    monthyear(dateValue) {
      let date = new Date(dateValue);
      let month = date.toLocaleString("en-US", { month: "short" });
      let year = date.getFullYear();
      return `${month} ${year}`;
    },

    daymonthyear(dateValue) {
      let date = new Date(dateValue);
      date.setDate(date.getDate() - 1);
      let day = date.getDate();
      let month = date.toLocaleString("en-US", { month: "short" });
      let year = date.getFullYear();
      return `${day} ${month} ${year}`;
    },

    async gettransactiongraph() {
      try {
        setAuthToken();
        let [transactionResponse] = await Promise.all([
          axios.get(Transactiongraph, config),
        ]);
        this.transactiongp = transactionResponse.data;
        this.tpsChart();
      } catch (error) {
        console.error("Error:", error);
      }
    },

    async getservice() {
      try {
        setAuthToken();
        let response = await axios.get(ServiceAvailable, config);
        this.Servicedata = response.data[response.data.length - 1];
        setInterval(() => {
          this.serviceMovements();
        }, 32000);
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async getavgpeak() {
      try {
        setAuthToken();
        let response = await axios.get(AverageTransaction, config);
        this.AvgPeak = response.data;
        this.at = Math.round(this.AvgPeak[0].avg_txn_per_second);
        this.pk = Math.round(this.AvgPeak[0].peak_txn_per_second);
        this.dt = this.AvgPeak[0].current_ts_peak_txn;
      } catch (error) {
        console.error("Error:", error);
      }
    },
    serviceMovements() {
      this.RPP = this.Servicedata?.retail_payment_platform;
      this.FPX = this.Servicedata?.fpx;
      this.MyDebit = this.Servicedata?.mydebit;
    },

    tpsChart() {
      const initialData = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      let chartOptions = {
        chart: {
          type: "area",
          backgroundColor: "#262D36",
        },
        title: {
          text: "",
          style: {
            color: "#ffffff",
          },
        },
        xAxis: {
          type: "datetime",
          labels: {
            style: {
              color: "#ffffff",
            },
          },
        },
        yAxis: {
          title: {
            text: "",
            style: {
              color: "#ffffff",
            },
          },
          gridLineWidth: 0,
          labels: {
            style: {
              color: "#ffffff",
            },
          },
        },
        legend: {
          itemStyle: {
            color: "#ffffff",
          },
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            type: "area",
            name: "Transactions",
            data: initialData,
            color: {
              linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
              stops: [
                [0, "rgba(255, 0, 0, 0.1)"],
                [1, "rgba(215, 91, 91, 1)"],
              ],
            },
          },
        ],
      };

      this.chart = Highcharts.chart("tps", chartOptions);

      this.updateChartData();
    },

    updateChartData() {
      let currentDate = new Date();
      let currentMinute = currentDate.getMinutes();
      let currentData = this.transactiongp.filter((entry1) => {
        let entryDate = new Date(entry1.dt);
        return entryDate.getMinutes() === currentMinute;
      });
      let formattedData = currentData.map((entry) => [
        new Date(entry.dt + "Z").getTime(),
        entry.tps,
      ]);

      let dataIndex = 0;

      let updateInterval = setInterval(() => {
        if (dataIndex < formattedData.length) {
          let newDataPoint = formattedData[dataIndex];
          this.chart.series[0].addPoint(newDataPoint, true, true);
          dataIndex++;
        } else {
          clearInterval(updateInterval);
        }
      }, 1000);
    },
  },
};
</script>
<style scoped>
.second-dash-card {
  background-color: #15191e;
  border: 0.1px solid #15191e;
}

.at-blue {
  color: #8bc5f5;
}

.service-span1 {
  border-style: solid;
  border: 1px solid #38b449;
  color: white;
  background-color: #38b449;
  border-radius: 1.31rem;
  font-size: 1.18rem;
  font-weight: 700;
}

.service-span2 {
  border-style: solid;
  border: 1px solid #38b449;
  padding-left: 1.43px;
  color: #38b449;
  font-weight: 700;
  font-size: 0.9rem;
  border-radius: 1.31rem;
  width: 7.2rem !important;
}

input[type="range"] {
  -webkit-appearance: none;
  appearance: none;

  width: 100%;
  cursor: pointer;
  outline: none;

  overflow: hidden;
  border-radius: 16px;
}

input[type="range"]::-webkit-slider-runnable-track {
  height: 15px;
  background: #ccc;
  border-radius: 16px;
}

input[type="range"]::-moz-range-track {
  height: 15px;
  background: #ccc;
  border-radius: 16px;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;

  height: 15px;
  width: 15px;
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid #38b449;

  box-shadow: -407px 0 0 400px #38b449;
}

input[type="range"]::-moz-range-thumb {
  height: 15px;
  width: 15px;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #38b449;

  box-shadow: -407px 0 0 400px #38b449;
}

.service-card {
  background-color: #262d36;
}



@media (min-width: 992px) {
  .container-fluid {
    max-height: 20rem !important;
  }

  .second-dash-card {
    height: 33vh !important;
  }

  .service-card {
    height: 31.5vh !important;
  }

  #tps {
    height: 11.5rem !important;
  }

  .heading-26 {
    font-size: 0.8rem !important;
    white-space: nowrap !important;
  }

  .graph-img-SD {
    width: 1.5rem;
  }

  .tpsfont {
    display: flex;
    white-space: nowrap;
    font-size: 0.8rem !important;
  }

  .Tpsrow {
    gap: 10px !important;
  }

  .borderclass {
    width: 7rem !important;
  }

  .borderclass1 {
    width: 9rem !important;
  }

  .datefont {
    white-space: nowrap !important;
    font-size: 0.9rem !important;
  }

  .servicetrack {
    width: 60% !important;
  }

  .heading-26 {
    font-size: 1.25rem !important;
    font-family: "Open Sans", sans-serif !important;
    color: #d2d2d2 !important;
  }
}
@media (min-width: 1200px) {
  .second-dash-card {
    height: 25vh !important;
  }

  .service-card {
    height: 13.6rem !important;
    border: 1px solid #394655;
    border-radius: 0.8rem;
  }

  .heading-26 {
    font-size: 1rem !important;
  }

  #tps {
    height: 10rem !important;
  }

  .heading-14 {
    font-size: 0.8rem !important;
  }

  .tpsfont {
    display: flex;
    white-space: nowrap;
    font-size: 0.8rem !important;
  }

  .iconimg {
    gap: 0px !important
  }

  .Tpsrow {
    gap: 5px !important;
  }

  .perRow {
    margin-top: 1rem !important;
  }

  .service-span2 {
    width:6.2rem !important;
  }
  .heading-32{
    font-size: 0.9rem !important;
  }
}
@media (min-width: 1400px) {
  .second-dash-card {
    height: 36vh !important;
  }

  .service-card {
    height: 16.8rem !important;
    border: 1px solid #394655;
    border-radius: 0.8rem;
  }

  .heading-26 {
    font-size: 1.3rem !important;
  }

  #tps {
    height: 12.5rem !important;
  }

  .heading-14 {
    font-size: 0.8rem !important;
  }
  .perRow {
    margin-top: 1.5rem !important;
  }
}

vice-card {
  height: 28vh !important;
  overflow: hidden !important;
}

.borderclass {
  width: 9rem !important;
}

input[type="range"] {
  height: 1rem !important;
  --thumb-size: 1.5rem !important;
}
</style>
